var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Viewer',{ref:"toastUiViewer",attrs:{"options":_vm.options,"initialValue":_vm.text}})
}
var staticRenderFns = []

export { render, staticRenderFns }